import React, { useState } from "react";
import { Grid, Tab, Tabs } from "@mui/material";
import styled from "styled-components";
import { isMobile } from "react-device-detect";
import { usePallet } from "../../../contexts/PalletContext";
import { useAuthorization } from "../../../contexts/AuthorizationContext";
import GerUsuariosTabConsumoIa from "./GerUsuariosTabConsumoIa";
import GerUsuariosTabVolumetria from "./GerUsuariosTabVolumetria";

type TInnerTab = "consumo_ia" | "volumetria";

const HeaderTabs = styled(Grid)`
  border-bottom: 1px solid #e0e0e0;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 6px 6px 0 0;
`;

const Panel = styled(Grid)`
  width: 100%;
`;

const GerUsuariosTabsVolumetria = (props: {
  id_user: number;
  index: number;
  activeTab: number;
  onChange?: () => void;
}) => {
  const { pallet } = usePallet();
  const { getConfig } = useAuthorization();
  const habConsumoIa = !!getConfig()?.habConsumoIa;
  const [innerTab, setInnerTab] = useState<TInnerTab>(habConsumoIa ? "consumo_ia" : "volumetria");

  return (
    <Grid container style={{ padding: "10px" }}>
      <HeaderTabs container>
        <Tabs
          value={innerTab}
          onChange={(_, v) => setInnerTab(v as TInnerTab)}
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons
          allowScrollButtonsMobile
          TabIndicatorProps={{
            style: {
              backgroundColor: pallet?.backgroundColorPrimary || "#3B0675",
              height: 3,
            },
          }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontFamily: pallet?.general?.fontFamily,
              fontSize: pallet?.general?.size14,
              fontWeight: pallet?.general?.weight_600,
              color: pallet?.textColorQuaternary || "#1E0736",
            },
            "& .Mui-selected": {
              color: `${pallet?.textColorTertiary || "#4B1196"} !important`,
            },
          }}
        >
          <Tab value="volumetria" label="Volumetria" />
          {habConsumoIa && <Tab value="consumo_ia" label="Consumo IA" />}
        </Tabs>
      </HeaderTabs>

      <Panel>
        {innerTab === "volumetria" && (
          <GerUsuariosTabVolumetria id_user={props.id_user} />
        )}
        {habConsumoIa && innerTab === "consumo_ia" && (
          <GerUsuariosTabConsumoIa id_user={props.id_user} />
        )}
      </Panel>
    </Grid>
  );
};

export default GerUsuariosTabsVolumetria;
